<template>
  <v-app :style="{background: this.$vuetify.theme.themes.light.background}">
    <loading :active.sync="loader.loading" :loader="loader.type" :color="loader.color" :height="loader.size.height" :width="loader.size.width"/>
    <v-content>
      <v-container class="fill-height" fluid>
        <v-row justify="center" dense>
          <v-snackbar v-model="notis.drawer" :color="notis.color" :timeout="10000" top right absolute>
            <v-icon dark>{{ notis.icon }}</v-icon> {{ notis.message }} <v-btn icon @click="notis.drawer = !notis.drawer"><v-icon>mdi-close-circle-outline</v-icon></v-btn>
          </v-snackbar>
        </v-row>
        <v-row align="center" justify="center">
          <v-col cols="12" sm="8" md="4">
            <v-card>
              <v-toolbar color="primary" flat>
                <v-toolbar-title class="white--text headline">お問い合わせ</v-toolbar-title>
              </v-toolbar>
              <v-card-text>
                <v-form ref="inquiry_form">
                  <v-text-field v-model="name" label="お名前" name="name" prepend-icon="mdi-account" type="text" counter="20" :rules="Rules.inquiryNameRules" :disabled="loader.loading">
                    <template v-slot:append>
                      <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                    </template>
                  </v-text-field>
                  <v-text-field v-model="email" label="メールアドレス" name="email" prepend-icon="mdi-email" type="text" counter="254" :rules="Rules.inquiryMailRules" :disabled="loader.loading">
                    <template v-slot:append>
                      <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                    </template>
                  </v-text-field>
                  <v-text-field v-model="title" label="お問い合わせ件名" name="title" prepend-icon="mdi-pen" type="text" counter="40" :rules="Rules.inquiryTitleRules" :disabled="loader.loading">
                    <template v-slot:append>
                      <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                    </template>
                  </v-text-field>
                  <v-textarea v-model="content" label="お問い合わせ内容" name="content" prepend-icon="mdi-message" rows="10" :rules="Rules.inquiryContentRules" no-resize counter="1000">
                    <template v-slot:append>
                      <v-chip small color="red" text-color="white"><strong>必須</strong></v-chip>
                    </template>
                  </v-textarea>
                </v-form>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="gray lighten-1" :to="{ name: 'Login' }">戻る</v-btn>
                <v-btn color="success" @click.prevent="showDialog" :disabled="loader.loading" class="ml-3">送信</v-btn>
              </v-card-actions>
            </v-card>
          </v-col>
        </v-row>
        <!-- 確認ダイアログ -->
        <v-row justify="center">
          <v-dialog v-model="dialogDrawer" persistent max-width="800">
            <v-card>
              <v-card-title class="headline">
                お問い合わせ内容確認
              </v-card-title>
              <v-card-text outlined>
                <v-list class="ml-10 mr-10">
                  <v-list-item>
                    <v-list-item-content>
                      <v-row>
                        <v-col cols="3" class="text-left">お名前</v-col>
                        <v-col cols="6" class="text-left">{{ name }}</v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <v-row>
                        <v-col cols="3" class="text-left">メールアドレス</v-col>
                        <v-col cols="5" class="text-left">{{ email }}</v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <v-row>
                        <v-col cols="3" class="text-left">お問い合わせ件名</v-col>
                        <v-col cols="5" class="text-left">{{ title }}</v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                  <v-list-item>
                    <v-list-item-content>
                      <v-row>
                        <v-col cols="3" class="text-left">お問い合わせ内容</v-col>
                        <v-col cols="6" class="text-left">{{ content }}</v-col>
                      </v-row>
                    </v-list-item-content>
                  </v-list-item>
                  <v-divider></v-divider>
                </v-list>
              </v-card-text>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="gray lighten-1" @click="dialogDrawer = false">戻る</v-btn>
                <v-btn color="success" @click.prevent="submit" :disabled="loader.loading" class="ml-3">送信</v-btn>
              </v-card-actions>
            </v-card>
          </v-dialog>
        </v-row>
      </v-container>
    </v-content>
  </v-app>
</template>

<script>
  import { useAppInsights } from '@/plugins/application-insights';
  import 'vue-awesome/icons';
  import Rule from "@/validation/rules";
  import Loading from 'vue-loading-overlay';
  import 'vue-loading-overlay/dist/vue-loading.css';
  import InquiriesApi from "@/api/inquiries-api"

  export default {
    name: "InquiryEntry",
    components: {
      Loading
    },
    data: () => ({
      loader: {
        loading: false,
        type: "dots",
        color: "#1C65FF",
        size: {
          height: 150,
          width: 200
        }
      },
      notis: {
        drawer: false,
        icon: "",
        color: "",
        message: ""
      },
      name: "",
      email: "",
      title: "",
      content: "",
      Rules: Rule,
      dialogDrawer: false
    }),
    methods: {
      showDialog() {
        if(this.$refs.inquiry_form.validate()) {
          this.dialogDrawer = true;
        } else {
          this.dialogDrawer = false;
        }
      },
      submit() {
        this.loader.loading = true;
        const params = {
          name: this.name,
          email: this.email,
          title: this.title,
          content: this.content,
          status: 0
        }
        const inquiriesApi = new InquiriesApi();
        const promise = inquiriesApi.store({ params: params });
        promise.then(() => {
          this.dialogDrawer = false;
          this.loader.loading = false;
          this.$router.push({ name: "Login" });
        }).catch(error => {
          useAppInsights().trackException({exception: error});
          this.dialogDrawer = false;
          this.loader.loading = false;
          this.showErrorNotis(error.response.data.message);
        }).finally(() => {
        });
      },
      showSuccessNotis(message) {
      this.notis.icon = "mdi-check-circle-outline";
      this.motis.color = "success";
      this.notis.message = message;
      this.notis.drawer = true;
      },
      showWarningNotis(message) {
        this.notis.icon = "mdi-alert-outline";
        this.notis.color = "warning";
        this.notis.message = message;
        this.notis.drawer = true;
      },
      showErrorNotis(message) {
        this.notis.icon = "mdi-close-octagon-outline";
        this.notis.color = "error";
        this.notis.message = message;
        this.notis.drawer = true;
      },
    }
  };
</script>
